export default class OrderConfigurationApi {
    constructor(axios, payload) {
        this.payload = payload
        this.axios = axios

    }

    getConfiguration() {
        
        return this.axios.post('index.php?m=proxycheap&json=1&c=OrderConfiguration', this.payload)
    }
}
